import styled from "styled-components";
import { theme } from "../../theme/toyotaTheme";
import * as Type from "../../globals/Type";

export const TradeInHeader = styled.div`
    margin-bottom: ${theme.space[1]}px;
    padding: ${theme.space[1]}px 0;
    border-bottom: 1px solid ${theme.colors.grey2};
`;

export const TradeInTitle = styled.h2.attrs(() => ({
    className: "t-milli-headline",
}))`
    margin-bottom: 0;
`;

export const TradeInBody = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const TradeInLabel = styled.div`
    font-family: ${theme.fonts.base};
    font-size: 1.3rem;
`;

export const TradeInValue = styled.span`
    display: flex;
    align-items: flex-start;
    margin-left: ${theme.space[1]}px;
    font-family: ${theme.fonts.semiBold};
    font-size: 1.3rem;
    white-space: nowrap;

    span {
        display: inline-block;
    }

    .icon,
    .icon::before {
        font-size: 1rem !important;
    }

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: ${theme.space[1]}px;
    }
`;

export const InsuranceClose = styled.div`
    cursor: pointer;
`;

// ----------------------------------------------------------------------
// Tradein notification
// ----------------------------------------------------------------------

export const TradeInNotificationWrapper = styled.div<{ show?: boolean }>`
    position: relative;
    margin-top: ${({ show }) => (show ? theme.space[3] : 1)}px;
`;

export const TradeInNotification = styled.div<{ show?: boolean }>`
    display: ${({ show }) => (show ? "block" : "none")};
    width: 100%;
    margin-bottom: ${theme.space[3]}px;
    padding: ${theme.space[3]}px;
    background-color: ${theme.colors.grey1};
    transition: opacity 0.3s;
    z-index: 1;
    pointer-events: ${({ show }) => (show ? "auto" : "none")};

    ${Type.SmallText} {
        display: block;
        margin-bottom: 0;
        text-align: center;
    }
`;

export const TradeInNotificationTitle = styled(Type.H4)`
    font-size: 1.6rem;
    text-align: center;
`;

export const TradeInNotificationIcon = styled.div<{ positive?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin: 0 auto;
    padding: 5px;
    color: ${theme.colors.primaryWhite};
    background-color: ${({ positive }) => (positive ? theme.colors.primaryBlack : theme.colors.primaryRed)};
    border-radius: 50%;
`;

export const TradeInNotificationClose = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    padding: ${theme.space[1]}px;
    cursor: pointer;

    html[dir="rtl"] & {
        left: 0;
        right: auto;
    }
`;
